import React from "react";
import { useSearchParams } from "react-router-dom";
import SimpleTrackingDashboard from "../../../components/admin/tracking-manager/SimpleTrackingDashboard";

const TrackingContainer = () => {
    const [searchParams] = useSearchParams();
    const userId = searchParams.get("userId");

    return <SimpleTrackingDashboard targetUserId={userId} />;
};

export default TrackingContainer;
